import {Button, EmptyState, Icon, Illustration} from '@sollapay/ui/components';
import {ReceiptPrintoutPayIllustration} from '@sollapay/ui/illustrations';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface PayoutsEmptyStateProps {
  onCreate?: () => void;
}

export const PayoutsEmptyState: FC<PayoutsEmptyStateProps> = ({onCreate}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <EmptyState
      illustration={
        <Illustration width={166} height={160}>
          <ReceiptPrintoutPayIllustration />
        </Illustration>
      }
      title={t('view.payouts.empty.title')}
      subtitle={t('view.payouts.empty.description')}
      action={
        onCreate && (
          <Button variant="primary" size="sm" onClick={onCreate}>
            <Icon name="add" />
            {t('view.payouts.empty.action')}
          </Button>
        )
      }
    />
  );
};
